import { render, staticRenderFns } from "./PopCustomerService.vue?vue&type=template&id=79aa0ae6&scoped=true&"
import script from "./PopCustomerService.vue?vue&type=script&lang=js&"
export * from "./PopCustomerService.vue?vue&type=script&lang=js&"
import style0 from "./PopCustomerService.vue?vue&type=style&index=0&id=79aa0ae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79aa0ae6",
  null
  
)

export default component.exports